export default __webpack_public_path__ + "static/media/hungry-monster.5f468390.PNG";